module.exports = __webpack_public_path__ + "static/nupperibo-da876b53e9dec9af09cb88c4d3d1899e.png";